webpackJsonp([82763537642259],{

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Collections = __webpack_require__(25);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Collections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'fetch'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'fetch()'
	      ),
	      ' method is used to retrieve a collection of resources.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can learn about how this method can be used to retrieve resources ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/collections/usage/retrieve/' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // Fetch the default set of models for this collection, resetting the\n      // collection when they arrive.\n      fetch: function(options) {\n        options = _.extend({ parse: true }, options);\n\n        // Reset the default models\n        const collection = this;\n        options.success = function(attributes) {\n          collection.reset(attributes, options);\n        };\n\n        return this.sync(\'read\', this, options);\n      },\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collections-properties-fetch-js-d19cfeef9c6d0fbc3824.js